import type { Icon } from '../../../src/lib/types'
export const mdiMinus: Icon = {
  "id": "minus",
  "name": "Minus",
  "path": "M19,13H5V11H19V13Z",
  "as": [
    "remove",
    "horizontal-line"
  ],
  "tags": [
    "Math"
  ]
}
export default mdiMinus